function Add() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" fill="none" viewBox="0 0 24 28">
      <circle cx="12" cy="15" r="11.5" stroke="#D2D0D5" transform="rotate(-180 12 15)"></circle>
      <path
        fill="var(--black-600)"
        d="M7.067 16.473h3.915v3.748h1.809v-3.748h3.924v-1.81h-3.924v-3.748h-1.81v3.749H7.068v1.809z"
        opacity="0.5"
      ></path>
    </svg>
  )
}

export default Add
